import React from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import {
  CONTENT_INPUT,
  CONTENT_RADIO,
  CONTENT_TOGGLE,
  SettingCategoryType,
  SettingContentType,
  settingsState,
  SettingType,
} from "../../recoil/settings";
import RadioSetting from "./RadioSetting";
import InputSetting from "./InputSetting";
import ToggleSetting from "./ToggleSetting";
import MessageController from "../../controller/MessageController";
import { useToast } from "../../controller/ToastController";
import ApiController from "../../controller/ApiController";
import { getRecoil } from "recoil-nexus";
import { masterStoreState } from "../../recoil/auth";
import { APP_TYPE } from "../../utils/DataType";
import { BackButton } from "../../components/BackButton";

const Settings = () => {
  const [settings, setSettings] = useRecoilState<SettingType>(settingsState);
  const keys = Object.keys(settings);
  const showToast = useToast();

  const editSetting = async (env_type: string, name: string, value: string) => {
    const res = await ApiController.store.setEnv({
      store_id: getRecoil(masterStoreState)!.store_id,
      app_type: APP_TYPE.KNOCK,
      env_list: [
        {
          env_type,
          name,
          value,
        },
      ],
    });

    if (res.data.ok && res.data.status === 200) {
      if (keys.find((item) => item === env_type)) {
        let settingsTemp = { ...settings };
        if (settingsTemp.hasOwnProperty(env_type)) {
          settingsTemp = {
            ...settingsTemp,
            [env_type]: {
              ...settingsTemp[env_type],
              [name]: { ...settingsTemp[env_type][name], value },
            },
          };
        }
        console.log("change setting", settingsTemp);
        setSettings({ ...settingsTemp });
        window.ReactNativeWebView?.postMessage(
          MessageController.getSetEnvRequestMessage({
            env_type,
            name,
            value,
          })
        );
      } else {
        showToast(`존재하지 않는 설정입니다.`, "error");
      }
    } else {
      showToast(`일시적인 오류입니다. 다시 시도해주세요.`, "error");
    }
  };

  console.log("settings", Object.entries(settings));

  return (
    <Style>
      <div className="knockContainer">
        <div className="header">
          <BackButton pathname="settings" />
          <h1>환경설정</h1>
        </div>
        <div className="body">
          <div className="contentWrap">
            {Object.entries(settings).map(
              (item: [string, SettingCategoryType], index: number) => (
                <div key={index} className="subCategory">
                  {/* <h1>{item[1].title}</h1> */}
                  {keys.find((content) => content === item[0]) &&
                    Object.entries(item[1]).map(
                      (
                        subItem: [string, SettingContentType],
                        subIndex: number
                      ) =>
                        subItem[1].config_type === CONTENT_TOGGLE ? (
                          <ToggleSetting
                            key={subIndex}
                            mainKey={item[0]}
                            subKey={subItem[0]}
                            item={subItem[1]}
                            editSetting={editSetting}
                          />
                        ) : subItem[1].config_type === CONTENT_INPUT ? (
                          <InputSetting
                            key={subIndex}
                            mainKey={item[0]}
                            subKey={subItem[0]}
                            item={subItem[1]}
                            editSetting={editSetting}
                          />
                        ) : (
                          subItem[1].config_type === CONTENT_RADIO && (
                            <RadioSetting
                              key={subIndex}
                              mainKey={item[0]}
                              subKey={subItem[0]}
                              item={subItem[1]}
                              editSetting={editSetting}
                            />
                          )
                        )
                    )}
                </div>
              )
            )}
          </div>
        </div>
        {/* <div className="footer">
          <button>
            <h3>저장</h3>
          </button>
        </div> */}
      </div>
    </Style>
  );
};
export default Settings;

const Style = styled.div`
  .knockContainer {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background: #000000;
  }
  .header {
    position: relative;
    text-align: center;
    padding: 40px 40px 20px 40px;
    h1 {
      color: #ffffff;
      font-weight: 600;
    }
    .backBtn {
      position: absolute;
      width: 36px;
      left: 40px;
    }
  }

  .body {
    height: 100%;
    padding: 30px 4%;
    overflow-y: auto;

    .contentWrap {
      .subCategory {
        padding: 30px 0;
        h1 {
          font-weight: 600;
          padding-bottom: 14px;
        }
      }
    }
  }

  .itemWrap {
    padding-left: 10px;
    padding-bottom: 30px;
    h2.title {
      font-weight: 500;
      padding-bottom: 12px;
    }
    .content {
      display: flex;
      align-items: center;
      gap: 8px;

      button {
        padding: 10px 14px;
        border-radius: 5px;
        background: #ffffff;
        h2 {
          line-height: 28px;
          color: #555555;
          font-weight: 600;
        }
      }
      button.active {
        background: #4dd2ae;
        h2 {
          color: #ffffff;
        }
      }
    }

    input {
      width: 40%;
      padding: 10px 14px;
      border-radius: 5px;
      font-size: 20px;
      line-height: 28px;
      color: #555555;
      font-weight: 500;
      border: none;
    }
    input:focus {
      outline-color: #4dd2ae;
    }
    button.save {
      background: #4dd2ae;
      h2 {
        color: #ffffff;
      }
    }

    .toggleWrap {
      width: 95px;
      height: 50px;
      padding: 5px;
      border-radius: 50px;
      background: #e5e5e5;
      transition: background-color 0.3s ease;

      .toggleItem {
        width: 40px;
        height: 40px;
        background: #ffffff;
        border-radius: 50px;
        transition: margin-left 0.3s ease;
      }
      .toggleItem.active {
        margin-left: 45px;
      }
    }
    .toggleWrap.active {
      background: #4dd2ae;
    }
  }

  .footer {
    position: sticky;
    bottom: 0;
    background: #000;
    width: 100%;
    padding: 30px 40px;
    button {
      width: 100%;
      padding: 12px 0;
      border-radius: 5px;
      background: #4dd2ae;
      cursor: pointer;
      h3 {
        font-size: 20px;
        line-height: 28px;
        font-weight: 600;
        color: #ffffff;
      }
    }
  }
`;
